// src/App.js

import React from "react";
import { Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import SignUp from "./pages/Signup";
import Login from "./pages/Login";
import NotificationSettings from "./pages/Notification";
import CustomerVoices from "./pages/Calculator.js";
import Review from "./pages/Review";
import DownloadDocuments from "./pages/Downloads.js";
//import "react-toastify/dist/ReactToastify.css";
import PForm from "./components/PForm";
import AddProductForm from "./pages/AddProductForm.js";
import QRCodeVerification from "./pages/QR";
import PrivateRoute from "./components/PrivateRoute.js";
import UserD from "./Dashboards/UserD";
import AuthRoute from "./components/AuthRoute";
import AdminD from "./Dashboards/AdminD";
import Settings from "./pages/Settings";
import AccountSettings from "./settings/AccountSettings";
import NotFoundPage from "./pages/PNF";
import Announcement from "./components/Announcement";
import ForgotPassword from "./pages/Forgotpassword.js";
import ResetPassword from "./pages/ResetPassword.js";
import ProgressBar from "./components/ProgressBar.js";
import Calculator from "./pages/Calculator.js";  
//import FAQs from "./pages/Faq.js";
import ChatBox from "./components/ChatBox"; // Import the ChatBox component
import MembershipPage from "./pages/Membership.js";
import NewsAndEvents from "./pages/NewsAndEvents.js";
import PaymentDetails from "./pages/PaymentDetails.js";
import Faqs from "./pages/Faqs.js";
import Products from "./pages/Products.js";

const App = () => {
  return (
    <div style={{overflow: "hidden"}}>
      <ProgressBar />
     
     <Routes>
 <Route path="/" element={<Home />} />
 {/* <Route path="/user/add-products" element={<PForm />} /> */}
 {/* <Route path="/user/signup" element={<SignUp />} /> */}
 {/* <Route path="/user/login" element={<Login />} /> */}
 {/* <Route path="/user/forgot-password" element={<ForgotPassword />} /> */}
 {/* <Route path="/user/reset-password/:token" element={<ResetPassword />} /> */}
 <Route path="/downloads" element={<DownloadDocuments />} /> {/* Add this line */}
 {/* <Route element={<PrivateRoute />}>
   <Route path="/admin/dashboard" element={<AdminD />} />
  
   <Route path="/admin/announcement" element={<Announcement />} />
   <Route path="/admin/" element={<AdminD />} />
   <Route path="/scanqr" element={<QRCodeVerification />} />
   <Route path="/user/add-products" element={<PForm />} />
   <Route path="/user/settings" element={<Settings />} />
   <Route path="/settings/account" element={<AccountSettings />} />
   <Route path="/user/notifications" element={<NotificationSettings />} />
 </Route> */}
 {/* <Route path="/user/dashboard" element={<UserD />} /> */}
 <Route path="/calculator" element={<Calculator />} /> 
 <Route path="/membership" element={<MembershipPage/>} /> 
 <Route path="/newsandevents" element={<NewsAndEvents/>} /> 
 <Route path="/paymentdetails" element={<PaymentDetails/>} /> 
 <Route path="/faqs" element={<Faqs/>} />
 <Route path="/products" element={<Products/>} /> 
 {/* <Route path="/user/review" element={<Review />} /> */}
 <Route path="*" element={<NotFoundPage />} />
</Routes>
    </div>
  );
};

export default App;
